
	import { Vue, Component, Prop, Watch } from "vue-property-decorator";
	import { PhoneRegExp, EmailRegExp, NumberRegExp } from "@/contants/regExp";
	import { provinceAndCityData, regionData, provinceAndCityDataPlus, regionDataPlus, CodeToText, TextToCode } from 'element-china-area-data'
	import { current } from "@/contants/current";
	import Success from "../SignUp/Modules/Success.vue";

	@Component({})
	export default class editForm extends Vue {
		private m: string = "";
		private userDatas : any[] = [];
		private current : any = {};
		private marginLeft : any = {};
		private cityformval : any = '';
		private allowUpdateInfo : any = '';
		private flags = {
			isLoading: false,
			isSubmit: true,
			isEditTel: false,
		};
		private options_ = regionData;
		@Prop({
			type: Object,
			default: {},
			required: true,
		})
		datas! : any;
		@Watch("datas", {
			immediate: true,
			deep: true,
		})
		watchDatas() {
			this.current = new current();
			this.userDatas = this.subData(this.current.cloneDeep(this.datas.form_UserVal));
			if (this.datas.ssl_muid) {
				this.flags.isEditTel = true;
				this.marginLeft = {
					marginLeft: "30%",
				};
			}
			console.log(this.datas, "userDatas", this.userDatas);
		}

		created() {
			const { m } = this.$route.query;
			this.m = String(m);
			this.InitInfo();

		}

		async InitInfo() {
			let params = {
				m: this.m,
			};
			let res = await this.$http.personalCenter.InitSignUpSetUserConfig(params);
			console.log("总数据", res);

			if (res.Code === 1000) {
				this.allowUpdateInfo = res.signUp_Set.allow_update_info
			}
		}
		handleChangeAdd(item : any) {
			//console.log(item[arr[0]], item[arr[1]], item[arr[2]]);
			item.formval = (this.$refs.cityRef as any)[0].getCheckedNodes()[0].pathLabels.join(",");
			console.log(item.formval)
			//item.formval = item.formval.toString()
		}
		/**
		 * @description: 校验
		 */
		handleRegBlur(item : any, ev ?: any, i ?: any) {
			let { formtitle, isreq, formval } = item;
			if (formval) {
				if (item.formtype === 1 && item.formfix === 1 && !PhoneRegExp.test(String(formval))) {
					item.SSL_errorMsg = "请输入正确的手机号";
					this.flags.isSubmit = false;
				} else if (item.formtype === 1 && item.formfix === 3 && !EmailRegExp.test(String(formval))) {
					item.SSL_errorMsg = "请输入正确的邮箱";
					this.flags.isSubmit = false;
				} else if (item.formtype === 1 && item.formfix === 6 && !NumberRegExp.test(String(formval))) {
					item.SSL_errorMsg = "请输入有效的数字";
					this.flags.isSubmit = false;
				}
			} else if ((isreq && !formval) || (isreq && formval == '')) {
				item.SSL_errorMsg = formtitle + "不能为空";
				this.flags.isSubmit = false;
			} else {
				item.SSL_errorMsg = "";
				this.flags.isSubmit = true;
			}
		}
		/**
		 * @description:二级数据中字符串类型的数组转为数组类型
		 */
		subData(forms : any[]) {
			for (let j = 0; j < forms.length; j++) {
				forms[j].SSL_errorMsg = "";
				let { formtype, formval, formjsonval, formtitle, defaultval } = forms[j];
				forms[j].formval = defaultval;
				if (formtype === 2 || formtype === 4 || formtype === 8 || formtype === 3) {
					let _formjsonval;
					if (typeof formjsonval == "string") {
						_formjsonval = JSON.parse(formjsonval);
					} else {
						_formjsonval = formjsonval;
					}
					//多选
					if (formtype === 3) {
						if (!formval) {
							forms[j].formval = [];
						}
						let _defaultval = defaultval.split(",");
						for (let i in _defaultval) {
							forms[j].formval.push(_defaultval[i]);
						}
					}
					forms[j].formjsonval = _formjsonval;
					//单选
					if (formtype === 2) {
						forms[j].formval = forms[j].defaultval;
					}
				}
				if (formtype === 6) {
					console.log(forms[j].defaultval)
					if (forms[j].defaultval.indexOf("-") != -1) {
						this.cityformval = []
						let defaultvalArr = forms[j].defaultval.split("-")
						if (defaultvalArr.length == 2) {
							this.cityformval = [TextToCode[defaultvalArr[0]].code, TextToCode[defaultvalArr[0]][defaultvalArr[1]].code]
						} else if (defaultvalArr.length == 3) {
							this.cityformval = [TextToCode[defaultvalArr[0]].code, TextToCode[defaultvalArr[0]][defaultvalArr[1]].code,
							TextToCode[defaultvalArr[0]][defaultvalArr[1]][defaultvalArr[2]].code]
						}
					} else {
						this.cityformval = []
						let defaultvalArr = forms[j].defaultval.split(",")
						if (defaultvalArr.length == 2) {
							this.cityformval = [TextToCode[defaultvalArr[0]].code, TextToCode[defaultvalArr[0]][defaultvalArr[1]].code]
						} else if (defaultvalArr.length == 3) {
							this.cityformval = [TextToCode[defaultvalArr[0]].code, TextToCode[defaultvalArr[0]][defaultvalArr[1]].code,
							TextToCode[defaultvalArr[0]][defaultvalArr[1]][defaultvalArr[2]].code]
						}
					}
				}
			}

			return forms;
		}
		/**
		 * @description: 处理提交的数据
		 */
		handleSubmit() {
			let _formLists = this.current.cloneDeep(this.userDatas);
			let data = [];
			for (let i = 0; i < _formLists.length; i++) {
				let { formtype, formval, formid, formtitle, formfix, defaultval, isreq } = _formLists[i];
				if ((formval === "请选择" || !formval || formval === '') && isreq) {
					//将 "请选择"及空值都转为后台要求的空字符串类型，
					this.userDatas[i].SSL_errorMsg = formtitle + "为必填项";
					this.flags.isSubmit = false;
					return false
				} else if (formtype === 2 && formfix === 1) {
					formval = formval.toString(",");
				} else if (formtype === 3 || formtype === 6) {
					formval = formval.toString(",");
				} else if (formtype === 1 && formfix === 3) {
					//校验邮箱
					this.handleRegBlur(_formLists[i], "", i);
				} else if (formtype === 1 && formfix === 6) {
					//校验数字
					this.handleRegBlur(_formLists[i], "", i);
				} else if (formtype === 9) {
					//处理日期格式，并且不能选择小于当前日期的时间
					let _formDate = new Date(formval).getTime();
					let _d = _formDate - new Date(new Date().toLocaleDateString()).getTime();

					if (!_formDate) {
						if (isreq) {
							this.userDatas[i].SSL_errorMsg = "请选择日期";
							this.flags.isSubmit = false;
						} else {
							formval = "";
						}
					} else {
						let _date = this.current.changeTimeStam(formval);
						formval = _date.year + "-" + _date.month + "-" + _date.day;
						this.flags.isSubmit = true;
					}
					/**else {
					  if (_d < 0) {
						this.userDatas[i].SSL_errorMsg = "不能小于当前日期";
						this.flags.isSubmit = false;
					  } else {
						let _date = this.current.changeTimeStam(formval);
						formval = _date.year + "-" + _date.month + "-" + _date.day;
						this.flags.isSubmit = true;
					  }
					}*/
				} else {
					this.flags.isSubmit = true;
				}

				data.push({
					value: formval,
					text: formtitle,
					formfix: formfix,
					formid: formid,
					formtype: formtype,
				});
				// console.log(formtitle, "->", formval);
			}
			for (let s in data) {
				//分割线不需要提交,去掉分割线
				data = data.filter((i : any) => {
					return i.formtype !== 7;
				});
			}

			// console.log(data);
			this.handleEditSignMeetingUser(data);
		}
		/**
		 * @description: 提交
		 */
		async handleEditSignMeetingUser(data : any[]) {
			if (this.flags.isSubmit) {
				this.flags.isLoading = true;
				let params = {
					m: String(this.$route.query.m),
					muid: this.datas.ssl_muid,
					UserEntity: [
						{
							DataEntity: data,
						},
					],
				};
				console.log(params);
				let Res = await this.$http.personalCenter.EditSignMeetingUser(params);
				//console.log("Res", Res);
				this.flags.isLoading = false;
				if (Res.Code === 1000) {
					this.$message({ message: "修改成功", type: "success" });
					// setTimeout(() => {
					// 	this.$router.go(0);
					// }, 1000);
				}
			}
		}
	}
